import { SetNewPasswordComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const SetNewPasswordUser = () => {
	return <SetNewPasswordComponent signInLink={APP_ROUTES.SIGN_IN_USER} />;
};

export default SetNewPasswordUser;
